import React, { FC } from 'react';
import { ExitIcon } from '../Icons/ExitIcon';

type TClearFiltersButtonProps = {
  onClick: () => void;
};

export const ClearFiltersButton: FC<TClearFiltersButtonProps> = ({ onClick }) => (
  <button
    onClick={onClick}
    className="flex items-center justify-center rounded-full min-w-10 !h-10 p-2 border border-t2-neutral-grey03 cursor-pointer"
  >
    <ExitIcon className="w-4 h-4 md:w-5 md:h-5" color="#242424" />
  </button>
);
